import { render, staticRenderFns } from "./SubAssetsTable.vue?vue&type=template&id=96402ae4&scoped=true"
import script from "./SubAssetsTable.vue?vue&type=script&lang=ts"
export * from "./SubAssetsTable.vue?vue&type=script&lang=ts"
import style0 from "./SubAssetsTable.vue?vue&type=style&index=0&id=96402ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96402ae4",
  null
  
)

export default component.exports